import { actionType } from "./actions";

let initialState = {
  store: null,
  current_credit: null,
};

function store(state = initialState, action) {
  switch (action.type) {
    case actionType.INIT_STORE:
      return { ...state, store: action.data };
    case actionType.SET_CREDIT:
      return { ...state, current_credit: action.data };
    case actionType.UPDATE_STORE:
      return { ...state, store: { ...state.store, ...action.data } };
    case actionType.CLEAR_STORE:
      return { ...state, store: null, current_credit: null };
    default:
      return state;
  }
}

export default store;
